import { create } from "zustand";
import { Locale } from "date-fns";
import { LocaleDefinition } from "../i18n.ts";
import { enUS } from "date-fns/locale";
import { persist } from "zustand/middleware";

type LanguageStore = {
  language: string;
  dateFnsLocale: Locale;
  setLocale: (localeDefinition: LocaleDefinition) => void;
};

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: "en",
      dateFnsLocale: enUS,
      setLocale: (localeDefinition: LocaleDefinition) =>
        set(() => ({
          language: localeDefinition.id,
          dateFnsLocale: localeDefinition.dateFnsLocale,
        })),
    }),
    {
      name: "language-store",
    },
  ),
);
